import { useSelector } from 'react-redux';
import {
  loadingFspProfileSelector,
  updatingFspConfigSelector,
} from '../consts';

const useShowProgress = () => {
  const loading = useSelector(loadingFspProfileSelector);
  const updating = useSelector(updatingFspConfigSelector);

  return loading || updating;
};

export default useShowProgress;
